import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Navbar from "../Items/Navbar";
import useVerify from "../useVerify";
import Title from "./items/Title";
import Moment from "moment";

function HistoryList() {
  useVerify("user");

  const [hasil, setHasil] = useState([]);
  const [loading, setLoading] = useState(true);

  const accountCookie = Cookies.get("account");
  const navigate = useNavigate();

  useEffect(() => {
    if (accountCookie === undefined) {
      return navigate("/login");
    }

    const accountTmp = JSON.parse(accountCookie);

    fetch(`${window.REACT_APP_BASE_URL}/api/hasils/${accountTmp.userId}`)
      .then((response) => response.json())
      .then((data) => {
        setHasil(data);
        setLoading(false);
      });

    // eslint-disable-next-line
  }, [accountCookie]);

  return (
    <div className="w-full min-h-screen bg-slate-200">
      <Navbar />
      <div className="w-full flex flex-col items-center pb-12">
        <div className="w-full md:w-2/3 flex flex-col justify-center items-center px-4">
          <Title />
          <hr className="w-full" />

          {loading ? (
            <div className="mt-12 text-gray-500">Memuat data...</div>
          ) : hasil.length === 0 ? (
            <div className="mt-12 text-gray-500">Belum ada riwayat hasil.</div>
          ) : (
            <div className="w-full mt-8 rounded-lg overflow-hidden border border-gray-200 shadow">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-white">
                  <tr>
                    <th className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase">
                      No
                    </th>
                    <th className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase">
                      Nama Tes
                    </th>
                    <th className="px-6 py-3 text-xs font-bold text-center text-gray-500 uppercase">
                      Total Skor
                    </th>
                    <th className="px-6 py-3 text-xs font-bold text-center text-gray-500 uppercase">
                      Tanggal
                    </th>
                    <th className="px-6 py-3 text-xs font-bold text-center text-gray-500 uppercase">
                      Aksi
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {hasil.map((item, index) => (
                    <tr key={item.hasilId} className="hover:bg-orange-50 transition">
                      <td className="px-6 py-4 text-sm text-gray-800">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 text-sm font-semibold text-gray-800 uppercase">
                        {item.namaTest}
                      </td>
                      <td className="px-6 py-4 text-sm text-center text-gray-800">
                        <span className="font-bold text-[#FF914D]">
                          {item.totalCorrectHasil}
                        </span>{" "}
                        / 500
                      </td>
                      <td className="px-6 py-4 text-sm text-center text-gray-800">
                        {Moment(item.createdAt).format("DD MMMM YYYY")}
                      </td>
                      <td className="px-6 py-4 text-center">
                        {/* FIX: pakai hasilId sebagai route params */}
                        <Link to={`/history/${item.hasilId}`}>
                          <button className="text-xs tracking-wide rounded py-1 px-3 bg-[#FF914D] font-semibold text-white hover:bg-[#e8742b] transition duration-300 shadow">
                            Detail
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HistoryList;
